// import { useState, useEffect } from "react"
// import { useParams, Link } from "react-router-dom"
// import TopNavbar from "../TopNavbar"
// import Footer from '../../Footer/Footer'

// export default function DistrictDetail() {
//     const { id } = useParams()
//     const [districts, setDistricts] = useState([])
//     const [loading, setLoading] = useState(true)
//     const [error, setError] = useState(null)

//     // Fetch all districts from your Node.js/Express API route
//     useEffect(() => {
//         fetch('https://api.lionsmd320.org/pages/api/district-leadership')
//             .then(res => {
//                 if (!res.ok) throw new Error('Failed to fetch districts data')
//                 return res.json()
//             })
//             .then(data => {
//                 // Handle response format ({ leaders: [...] } or direct array)
//                 const items = data.leaders || data || []
//                 setDistricts(items)
//                 setLoading(false)
//             })
//             .catch(err => {
//                 console.error(err)
//                 setError('Could not load district information.')
//                 setLoading(false)
//             })
//     }, [])

//     if (loading) {
//         return (
//             <div style={{ padding: "96px 16px", textAlign: "center", color: "#6b7280" }}>
//                 Loading district information...
//             </div>
//         )
//     }

//     if (error) {
//         return (
//             <div style={{ padding: "96px 16px", textAlign: "center", color: "#ef4444" }}>
//                 {error}
//             </div>
//         )
//     }

//     // Find current district by matching label/slug case-insensitively with URL parameter
//     const d = districts.find(item =>
//         (item.label && item.label.toLowerCase() === id?.toLowerCase()) ||
//         (item.district_name && item.district_name.toLowerCase() === id?.toLowerCase())
//     )

//     if (!d) {
//         return (
//             <div style={{ padding: "96px 16px", textAlign: "center" }}>
//                 <div style={{ fontSize: "60px", fontWeight: 900, color: "#e5e7eb", marginBottom: "16px" }}>404</div>
//                 <p style={{ color: "#6b7280", marginBottom: "24px" }}>District not found.</p>
//                 <Link to="/multiple-districts" style={{ backgroundColor: "#0067B1", color: "#ffffff", padding: "10px 24px", borderRadius: "6px", fontWeight: 600, textDecoration: "none", display: "inline-block" }}>
//                     View All Districts
//                 </Link>
//             </div>
//         )
//     }

//     // Map database properties cleanly to fallback/display variables
//     const districtLabel = d.label || d.district_name || ''
//     const regionName = d.region || 'General Region'
//     const clubsCount = d.clubs || 0
//     const membersCount = d.members || 0
//     const taglineText = d.tagline || ''
//     const emailAddress = d.email || ''

//     // Leadership attributes (Governor, FVDG, SVDG)
//     const governorName = d.name || d.governor || 'Not Available'
//     const governorMobile = d.mobile || d.govMobile || 'Not Available'
//     const governorImg = d.profile_image || d.governorImage || ''

//     const fvdgName = d.fvdg || 'FVDG Representative'
//     const fvdgMobile = d.fvdg_mobile || d.fvdgMobile || 'Not Available'
//     const fvdgImg = d.fvdg_image || d.fvdgImage || ''

//     const svdgName = d.svdg || 'SVDG Representative'
//     const svdgMobile = d.svdg_mobile || d.svdgMobile || 'Not Available'
//     const svdgImg = d.svdg_image || d.svdgImage || ''

//     return (
//         <>
//             <TopNavbar />
//             <div>
//                 <div style={{ position: "relative", height: "230px", backgroundColor: "#0067B1", overflow: "hidden" }}>
//                     <div style={{ position: "absolute", inset: 0, backgroundImage: `repeating-linear-gradient(45deg,rgba(255,255,255,0.055) 0px,rgba(255,255,255,0.055) 1px,transparent 1px, transparent 32px )` }} />
//                     <div style={{ position: "absolute", right: "30px", top: "20px", fontSize: "165px", lineHeight: 1, fontWeight: 900, color: "rgba(255,255,255,0.045)", letterSpacing: "-8px", userSelect: "none" }}>
//                         {districtLabel}
//                     </div>

//                     <div style={{ position: "relative", zIndex: 2, width: "100%", boxSizing: "border-box", padding: "28px 50px 0", textAlign: "left" }}>
//                         <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "7px", width: "100%", marginBottom: "18px", fontSize: "12px", color: "rgba(255,255,255,0.75)" }}>
//                             <Link to="/" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "none" }}>Home</Link>
//                             <span>/</span>
//                             <Link to="/multiple-districts" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "none" }}>Multiple Districts</Link>
//                             <span>/</span>
//                             <span style={{ color: "#fff", fontWeight: 600 }}>District {districtLabel}</span>
//                         </div>
//                         <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "fit-content", backgroundColor: "rgba(255,213,0,0.18)", border: "1px solid rgba(255,213,0,0.35)", borderRadius: "999px", padding: "4px 13px", margin: "0 0 12px 0" }}>
//                             <span style={{ color: "#FFD500", fontSize: "10px", fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase", whiteSpace: "nowrap" }}>
//                                 {regionName}
//                             </span>
//                         </div>
//                         <h1 style={{ display: "block", width: "100%", margin: "0", padding: "0", color: "#ffffff", fontSize: "46px", lineHeight: "1.05", fontWeight: 800, letterSpacing: "-1.5px" }}>
//                             District {districtLabel}
//                         </h1>
//                         <p style={{ display: "block", width: "100%", margin: "10px 0 0", padding: "0", color: "rgba(255,255,255,0.62)", fontSize: "16px", lineHeight: 1.5 }}>
//                             {taglineText}
//                         </p>
//                     </div>
//                 </div>

//                 <div style={{ backgroundColor: "#005090" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "20px 16px" }}>
//                         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "24px" }}>
//                             {[
//                                 { value: clubsCount.toString(), label: "Clubs" },
//                                 { value: Number(membersCount).toLocaleString(), label: "Members" },
//                                 // { value: establishedYear ? "Est. " + establishedYear : "Est. N/A", label: "Established" },
//                                 { value: governorName, label: "District Governor" },
//                             ].map((s) => (
//                                 <div key={s.label} style={{ textAlign: "center" }}>
//                                     <div style={{ fontSize: "20px", fontWeight: 800, color: "#FFD500" }}>{s.value}</div>
//                                     <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 500, marginTop: "2px" }}>{s.label}</div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Content */}
//                 <section style={{ padding: "64px 16px", backgroundColor: "#ffffff" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//                         <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "40px" }}>
//                             <div>
//                                 <div style={{ marginBottom: "40px" }}>
//                                     <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>About District {districtLabel}</span>
//                                     <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "16px" }}>Introduction</h2>
//                                     <p style={{ color: "#4b5563", lineHeight: 1.7, marginBottom: "16px" }}>
//                                         District {districtLabel} ({regionName}) is one of the premier districts comprising MD 320. With {clubsCount} active clubs and {Number(membersCount).toLocaleString()} dedicated members, our district represents a vibrant and committed Lions community.
//                                     </p>
//                                     <p style={{ color: "#4b5563", lineHeight: 1.7 }}>
//                                         Since our establishment, District {districtLabel} has maintained a proud tradition of humanitarian service under the leadership of {governorName}.
//                                     </p>
//                                 </div>

//                                 <div>
//                                     <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>Leadership Team</span>
//                                     <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "24px" }}>DG Team - District {districtLabel}</h2>
//                                     <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "24px" }}>
//                                         {/* Governor Card */}
//                                         <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
//                                             {governorImg ? (
//                                                 <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
//                                                     <img src={governorImg} alt={governorName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
//                                                 </div>
//                                             ) : (
//                                                 <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>DG</div>
//                                             )}
//                                             <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
//                                                 <div>
//                                                     <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>District Governor</span>
//                                                     <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{governorName}</h3>
//                                                 </div>
//                                                 <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
//                                                     <span>📞 {governorMobile}</span>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* FVDG Card */}
//                                         <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
//                                             {fvdgImg ? (
//                                                 <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
//                                                     <img src={fvdgImg} alt={fvdgName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
//                                                 </div>
//                                             ) : (
//                                                 <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>1VDG</div>
//                                             )}
//                                             <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
//                                                 <div>
//                                                     <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>First Vice DG</span>
//                                                     <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{fvdgName}</h3>
//                                                 </div>
//                                                 <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
//                                                     <span>📞 {fvdgMobile}</span>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* SVDG Card */}
//                                         <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
//                                             {svdgImg ? (
//                                                 <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
//                                                     <img src={svdgImg} alt={svdgName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
//                                                 </div>
//                                             ) : (
//                                                 <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>2VDG</div>
//                                             )}
//                                             <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
//                                                 <div>
//                                                     <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>Second Vice DG</span>
//                                                     <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{svdgName}</h3>
//                                                 </div>
//                                                 <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
//                                                     <span>📞 {svdgMobile}</span>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Sidebar */}
//                             <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
//                                 <div style={{ backgroundColor: "#FFD500", borderRadius: "12px", padding: "24px" }}>
//                                     <h3 style={{ fontWeight: 800, color: "#0067B1", fontSize: "18px", marginBottom: "8px" }}>Submit a Document</h3>
//                                     <p style={{ color: "rgba(0, 103, 177, 0.7)", fontSize: "14px", marginBottom: "16px" }}>Upload reports or resources for District {districtLabel}.</p>
//                                     <Link to="/upload" style={{ display: "block", backgroundColor: "#0067B1", color: "#ffffff", fontWeight: "bold", fontSize: "14px", padding: "10px", borderRadius: "4px", textAlign: "center", textDecoration: "none" }}>
//                                         Upload Document
//                                     </Link>
//                                 </div>

//                                 <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", padding: "24px" }}>
//                                     <h3 style={{ fontWeight: "bold", color: "#0067B1", fontSize: "16px", marginBottom: "16px" }}>District Contact</h3>
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "14px" }}>
//                                         <div style={{ color: "#374151" }}>👤 {governorName}</div>
//                                         <div style={{ color: "#374151" }}>✉️ {emailAddress}</div>
//                                     </div>
//                                     <Link to="/contact" style={{ display: "block", marginTop: "16px", textAlign: "center", fontSize: "12px", fontWeight: "bold", color: "#0067B1", border: "1px solid #0067B1", padding: "10px", borderRadius: "4px", textDecoration: "none", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                                         Get in Touch
//                                     </Link>
//                                 </div>

//                                 {/* Other Districts List */}
//                                 <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", padding: "24px" }}>
//                                     <h3 style={{ fontWeight: "bold", color: "#0067B1", fontSize: "16px", marginBottom: "16px" }}>Other Districts</h3>
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                                         {districts
//                                             .filter(item => (item.label || item.district_name)?.toLowerCase() !== id?.toLowerCase())
//                                             .slice(0, 5)
//                                             .map((item, idx) => {
//                                                 const lbl = item.label || item.district_name || idx
//                                                 return (
//                                                     <Link key={idx} to={`/district/${lbl.toLowerCase()}`} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderRadius: "4px", fontSize: "14px", color: "#4b5563", textDecoration: "none" }}>
//                                                         <span style={{ fontWeight: 600 }}>{lbl}</span>
//                                                         <span style={{ fontSize: "12px", color: "#9ca3af" }}>{item.region}</span>
//                                                     </Link>
//                                                 )
//                                             })
//                                         }
//                                         <Link to="/multiple-districts" style={{ display: "block", textAlign: "center", fontSize: "12px", color: "#0067B1", fontWeight: "bold", paddingTop: "8px", textDecoration: "none" }}>
//                                             View all districts →
//                                         </Link>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </div>
//             <Footer />
//         </>
//     )
// }











import { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import TopNavbar from "../TopNavbar"
import Footer from '../../Footer/Footer'

export default function DistrictDetail() {
    const { id } = useParams()
    const [districts, setDistricts] = useState([])
    const [activities, setActivities] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    // Handle resize for dynamic responsive inline styling adjustments
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // Fetch district leadership and activities data
    useEffect(() => {
        Promise.all([
            fetch('https://api.lionsmd320.org/pages/api/district-leadership').then(res => {
                if (!res.ok) throw new Error('Failed to fetch districts data')
                return res.json()
            }),
            fetch('https://api.lionsmd320.org/pages/api/api/activities').then(res => {
                if (!res.ok) throw new Error('Failed to fetch activities data')
                return res.json()
            }).catch(() => ({ multipleDistricts: [] })) // fallback if activities endpoint fails
        ])
            .then(([leadershipData, activitiesData]) => {
                const items = leadershipData.leaders || leadershipData || []
                setDistricts(items)

                const actRows = activitiesData.multipleDistricts || activitiesData.rows || activitiesData || []
                setActivities(actRows)

                setLoading(false)
            })
            .catch(err => {
                console.error(err)
                setError('Could not load district information.')
                setLoading(false)
            })
    }, [])

    if (loading) {
        return (
            <div style={{ padding: "96px 16px", textAlign: "center", color: "#6b7280" }}>
                Loading district information...
            </div>
        )
    }

    if (error) {
        return (
            <div style={{ padding: "96px 16px", textAlign: "center", color: "#ef4444" }}>
                {error}
            </div>
        )
    }

    const d = districts.find(item =>
        (item.label && item.label.toLowerCase() === id?.toLowerCase()) ||
        (item.district_name && item.district_name.toLowerCase() === id?.toLowerCase())
    )

    if (!d) {
        return (
            <div style={{ padding: "96px 16px", textAlign: "center" }}>
                <div style={{ fontSize: "60px", fontWeight: 900, color: "#e5e7eb", marginBottom: "16px" }}>404</div>
                <p style={{ color: "#6b7280", marginBottom: "24px" }}>District not found.</p>
                <Link to="/multiple-districts" style={{ backgroundColor: "#0067B1", color: "#ffffff", padding: "10px 24px", borderRadius: "6px", fontWeight: 600, textDecoration: "none", display: "inline-block" }}>
                    View All Districts
                </Link>
            </div>
        )
    }

    const districtLabel = d.label || d.district_name || ''
    const regionName = d.region || 'General Region'
    const clubsCount = d.clubs || 0
    const membersCount = d.members || 0
    const taglineText = d.tagline || ''
    const emailAddress = d.email || ''

    const governorName = d.name || d.governor || 'Not Available'
    const governorMobile = d.mobile || d.govMobile || 'Not Available'
    const governorImg = d.profile_image || d.governorImage || ''

    const fvdgName = d.fvdg || 'FVDG Representative'
    const fvdgMobile = d.fvdg_mobile || d.fvdgMobile || 'Not Available'
    const fvdgImg = d.fvdg_image || d.fvdgImage || ''

    const svdgName = d.svdg || 'SVDG Representative'
    const svdgMobile = d.svdg_mobile || d.svdgMobile || 'Not Available'
    const svdgImg = d.svdg_image || d.svdgImage || ''

    // Filter active activities matching this district (case-insensitive check)
    const districtActivities = activities.filter(act => {
        const matchDistrict = act.district?.trim().toLowerCase() === districtLabel?.trim().toLowerCase()
        const isActive = Number(act.isActive) === 1
        return matchDistrict && isActive
    })

    return (
        <>
            <TopNavbar />
            <div>
                {/* Hero Banner */}
                <div style={{ position: "relative", minHeight: "230px", backgroundColor: "#0067B1", overflow: "hidden" }}>
                    <div style={{ position: "absolute", inset: 0, backgroundImage: `repeating-linear-gradient(45deg,rgba(255,255,255,0.055) 0px,rgba(255,255,255,0.055) 1px,transparent 1px, transparent 32px )` }} />
                    
                    {/* Background watermark text hidden on mobile to prevent overflow */}
                    {!isMobile && (
                        <div style={{ position: "absolute", right: "30px", top: "20px", fontSize: "165px", lineHeight: 1, fontWeight: 900, color: "rgba(255,255,255,0.045)", letterSpacing: "-8px", userSelect: "none" }}>
                            {districtLabel}
                        </div>
                    )}

                    <div style={{ position: "relative", zIndex: 2, width: "100%", boxSizing: "border-box", padding: isMobile ? "20px 16px" : "28px 50px 0", textAlign: "left" }}>
                        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "flex-start", gap: "7px", width: "100%", marginBottom: "18px", fontSize: "12px", color: "rgba(255,255,255,0.75)" }}>
                            <Link to="/" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "none" }}>Home</Link>
                            <span>/</span>
                            <Link to="/multiple-districts" style={{ color: "rgba(255,255,255,0.85)", textDecoration: "none" }}>Multiple Districts</Link>
                            <span>/</span>
                            <span style={{ color: "#fff", fontWeight: 600 }}>District {districtLabel}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "fit-content", backgroundColor: "rgba(255,213,0,0.18)", border: "1px solid rgba(255,213,0,0.35)", borderRadius: "999px", padding: "4px 13px", margin: "0 0 12px 0" }}>
                            <span style={{ color: "#FFD500", fontSize: "10px", fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase", whiteSpace: "nowrap" }}>
                                {regionName}
                            </span>
                        </div>
                        <h1 style={{ display: "block", width: "100%", margin: "0", padding: "0", color: "#ffffff", fontSize: isMobile ? "32px" : "46px", lineHeight: "1.1", fontWeight: 800, letterSpacing: "-1.5px" }}>
                            District {districtLabel}
                        </h1>
                        <p style={{ display: "block", width: "100%", margin: "10px 0 0", padding: "0", color: "rgba(255,255,255,0.62)", fontSize: isMobile ? "14px" : "16px", lineHeight: 1.5 }}>
                            {taglineText}
                        </p>
                    </div>
                </div>

                {/* Stats Bar */}
                <div style={{ backgroundColor: "#005090" }}>
                    <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "20px 16px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(150px, 1fr))", gap: "24px" }}>
                            {[
                                { value: clubsCount.toString(), label: "Clubs" },
                                { value: Number(membersCount).toLocaleString(), label: "Members" },
                                { value: governorName, label: "District Governor" },
                            ].map((s) => (
                                <div key={s.label} style={{ textAlign: "center" }}>
                                    <div style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: 800, color: "#FFD500", wordBreak: "break-word" }}>{s.value}</div>
                                    <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 500, marginTop: "2px" }}>{s.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <section style={{ padding: isMobile ? "32px 16px" : "64px 16px", backgroundColor: "#ffffff" }}>
                    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr", gap: "40px" }}>
                            <div>
                                <div style={{ marginBottom: "40px" }}>
                                    <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>About District {districtLabel}</span>
                                    <h2 style={{ fontSize: isMobile ? "20px" : "24px", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "16px" }}>Introduction</h2>
                                    <p style={{ color: "#4b5563", lineHeight: 1.7, marginBottom: "16px", fontSize: isMobile ? "14px" : "16px" }}>
                                        District {districtLabel} ({regionName}) is one of the premier districts comprising MD 320. With {clubsCount} active clubs and {Number(membersCount).toLocaleString()} dedicated members, our district represents a vibrant and committed Lions community.
                                    </p>
                                    <p style={{ color: "#4b5563", lineHeight: 1.7, fontSize: isMobile ? "14px" : "16px" }}>
                                        Since our establishment, District {districtLabel} has maintained a proud tradition of humanitarian service under the leadership of {governorName}.
                                    </p>
                                </div>

                                <div style={{ marginBottom: "40px" }}>
                                    <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>Leadership Team</span>
                                    <h2 style={{ fontSize: isMobile ? "20px" : "24px", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "24px" }}>DG Team - District {districtLabel}</h2>
                                    
                                    {/* DG Team Cards: 1 column on mobile, 3 columns on LG/Desktop */}
                                    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: "24px" }}>
                                        
                                        {/* Governor Card */}
                                        <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                                            {governorImg ? (
                                                <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                                                    <img src={governorImg} alt={governorName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
                                                </div>
                                            ) : (
                                                <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>DG</div>
                                            )}
                                            <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                <div>
                                                    <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>District Governor</span>
                                                    <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{governorName}</h3>
                                                </div>
                                                <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
                                                    <span>📞 {governorMobile}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* FVDG Card */}
                                        <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                                            {fvdgImg ? (
                                                <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                                                    <img src={fvdgImg} alt={fvdgName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
                                                </div>
                                            ) : (
                                                <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>1VDG</div>
                                            )}
                                            <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                <div>
                                                    <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>First Vice DG</span>
                                                    <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{fvdgName}</h3>
                                                </div>
                                                <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
                                                    <span>📞 {fvdgMobile}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* SVDG Card */}
                                        <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                                            {svdgImg ? (
                                                <div style={{ height: "192px", backgroundColor: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                                                    <img src={svdgImg} alt={svdgName} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }} />
                                                </div>
                                            ) : (
                                                <div style={{ height: "192px", backgroundColor: "#f0f7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#0067B1", fontWeight: "bold" }}>2VDG</div>
                                            )}
                                            <div style={{ padding: "16px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                <div>
                                                    <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "2px 8px", borderRadius: "4px" }}>Second Vice DG</span>
                                                    <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "16px", marginTop: "8px" }}>{svdgName}</h3>
                                                </div>
                                                <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #f3f4f6", fontSize: "12px", color: "#4b5563" }}>
                                                    <span>📞 {svdgMobile}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* District Activities & Gallery Section (Filtered by district and isActive === 1) */}
                                <div>
                                    <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>Activities & Gallery</span>
                                    <h2 style={{ fontSize: isMobile ? "20px" : "24px", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "24px" }}>District {districtLabel} Highlights</h2>

                                    {districtActivities.length === 0 ? (
                                        <div style={{ padding: "32px", textAlign: "center", backgroundColor: "#f9fafb", borderRadius: "12px", border: "1px dashed #e5e7eb", color: "#6b7280", fontSize: "14px" }}>
                                            No active activity records found for District {districtLabel} at the moment.
                                        </div>
                                    ) : (
                                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", gap: "24px" }}>
                                            {districtActivities.map((act) => (
                                                <div key={act.id} style={{ border: "1px solid #f3f4f6", borderRadius: "12px", overflow: "hidden", display: "flex", flexDirection: "column", backgroundColor: "#ffffff", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)" }}>
                                                    {act.imageUrl && (
                                                        <div style={{ height: "220px", backgroundColor: "#f3f4f6", overflow: "hidden" }}>
                                                            <img src={act.imageUrl} alt={act.activity || "Activity Image"} style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} />
                                                        </div>
                                                    )}
                                                    <div style={{ padding: "20px", display: "flex", flexDirection: "column", flex: 1, justifyContent: "space-between" }}>
                                                        <div>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                                                <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.05em", color: "#0067B1", backgroundColor: "#f0f7ff", padding: "3px 10px", borderRadius: "4px" }}>
                                                                    {act.activity || "General Activity"}
                                                                </span>
                                                                <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                                                                    {act.createdAt ? new Date(act.createdAt).toLocaleDateString() : ""}
                                                                </span>
                                                            </div>
                                                            <p style={{ color: "#374151", fontSize: "14px", lineHeight: "1.6", margin: "0" }}>
                                                                {act.caption}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Sidebar */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                                <div style={{ backgroundColor: "#FFD500", borderRadius: "12px", padding: "24px" }}>
                                    <h3 style={{ fontWeight: 800, color: "#0067B1", fontSize: "18px", marginBottom: "8px" }}>Submit a Document</h3>
                                    <p style={{ color: "rgba(0, 103, 177, 0.7)", fontSize: "14px", marginBottom: "16px" }}>Upload reports or resources for District {districtLabel}.</p>
                                    <Link to="/upload" style={{ display: "block", backgroundColor: "#0067B1", color: "#ffffff", fontWeight: "bold", fontSize: "14px", padding: "10px", borderRadius: "4px", textAlign: "center", textDecoration: "none" }}>
                                        Upload Document
                                    </Link>
                                </div>

                                <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", padding: "24px" }}>
                                    <h3 style={{ fontWeight: "bold", color: "#0067B1", fontSize: "16px", marginBottom: "16px" }}>District Contact</h3>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "14px", wordBreak: "break-word" }}>
                                        <div style={{ color: "#374151" }}>👤 {governorName}</div>
                                        <div style={{ color: "#374151" }}>✉️ {emailAddress}</div>
                                    </div>
                                    <Link to="/contact" style={{ display: "block", marginTop: "16px", textAlign: "center", fontSize: "12px", fontWeight: "bold", color: "#0067B1", border: "1px solid #0067B1", padding: "10px", borderRadius: "4px", textDecoration: "none", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                        Get in Touch
                                    </Link>
                                </div>

                                {/* Other Districts List */}
                                <div style={{ border: "1px solid #f3f4f6", borderRadius: "12px", padding: "24px" }}>
                                    <h3 style={{ fontWeight: "bold", color: "#0067B1", fontSize: "16px", marginBottom: "16px" }}>Other Districts</h3>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                        {districts
                                            .filter(item => (item.label || item.district_name)?.toLowerCase() !== id?.toLowerCase())
                                            .slice(0, 5)
                                            .map((item, idx) => {
                                                const lbl = item.label || item.district_name || idx
                                                return (
                                                    <Link key={idx} to={`/district/${lbl.toLowerCase()}`} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderRadius: "4px", fontSize: "14px", color: "#4b5563", textDecoration: "none" }}>
                                                        <span style={{ fontWeight: 600 }}>{lbl}</span>
                                                        <span style={{ fontSize: "12px", color: "#9ca3af" }}>{item.region}</span>
                                                    </Link>
                                                )
                                            })
                                        }
                                        <Link to="/multiple-districts" style={{ display: "block", textAlign: "center", fontSize: "12px", color: "#0067B1", fontWeight: "bold", paddingTop: "8px", textDecoration: "none" }}>
                                            View all districts →
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}